<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">OVERTIME REQUEST APPROVED LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to manage overtime requests.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-5">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              class="custom_excel_btn"
              variant="outlined"
              @click="exportExcelOvertimeRequestList"
            >
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-col>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficerTitle"
              :items="officerTitleList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Officer Category"
              multiple
              placeholder="Select Officer Category"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedOfficer"
              :items="officersListBasedOnRole"
              clearable
              item-title="name"
              item-value="id"
              label="Officer"
              multiple
              placeholder="Select Officer Name"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-date-input
              v-model="dates"
              label="Select Date Range"
              prepend-icon=""
              prepend-inner-icon="$calendar"
              multiple="range"
              variant="outlined"
              clearable
              @update:model-value="onDateRangeSelected"
              @click:clear="clearDateRange"
              density="comfortable"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedPremiseCode"
              :items="premiseCodeList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Premise Code"
              placeholder="Select Premise Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedDivisionCode"
              :items="divisionCodeList"
              clearable
              item-title="name"
              item-value="id"
              label="Division Code"
              placeholder="Select Division Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
              <v-text-field
                  v-model="search" append-inner-icon="mdi-magnify" clearable hide-details label="Search"
                  placeholder="Search" variant="outlined" density="comfortable" class="custom_input_field_color"
              ></v-text-field>
            </v-col>
        </v-row>

        <v-row
          class="pa-2 mb-4"
          style="
            background-color: #fff3cd;
            border: 1px solid #566573;
            border-radius: 4px;
          "
        >
          <v-col class="d-flex align-center" cols="12">
            <v-icon color="success" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333"
              >ON TIME</span
            >

            <v-icon color="error" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span style="font-size: 12px; color: #333">LATE</span>
          </v-col>
        </v-row>

        <v-data-table :group-by="groupBy" :headers="headers"
                    :items="filteredOvertimeRequestList" item-value="user_id">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <VBtn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)"></VBtn>
                                <span class="text-muted">
                                        {{item.value.split(' - ')[0]}}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold pl-10">Employee ID: {{item.value.split(' - ')[1] }}</span>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div >
                          <div v-if="item.attendance != null">
                            <v-icon
                              v-if="item.attendance.status =='On-Time'"
                              color="success"
                              size="small"
                              class="mr-1"
                            >
                              mdi-checkbox-blank-circle
                            </v-icon>
                            <v-icon
                              v-else
                              color="error"
                              size="small"
                              class="mr-1"
                            >
                              mdi-checkbox-blank-circle
                            </v-icon>
                          </div>
                            <div v-if="item.attendance != null">
                                <span>{{ item.attendance.day_in_time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.attendance.day_in_location }}</span>
                                
                            </div>
                            <div v-else>
                                <span>Not yet</span>
                                
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                      <div v-if="item.attendance != null">
                            <v-icon
                              v-if="((item.attendance.status =='On-Time') && (item.attendance.day_out_time))"
                              color="success"
                              size="small"
                              class="mr-1"
                            >
                              mdi-checkbox-blank-circle
                            </v-icon>
                            <v-icon
                              v-else
                              color="error"
                              size="small"
                              class="mr-1"
                            >
                              mdi-checkbox-blank-circle
                            </v-icon>
                          </div>
                        <div v-if="item.attendance != null">
                            <span>{{ item.attendance.day_out_time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.attendance.day_out_location }}</span>
                            
                        </div>
                        <div v-else>
                                <span>Not yet</span>
                            </div>
                    </template>

                    <template v-slot:[`item.request_hours`]="{ item }">
                        <div class="text-left">
                            <span class="blue--text "><strong class="black--text font-weight-bold">From:</strong> {{
                                item.request_time_from }}</span><br />
                            <span class="blue--text "><strong class="black--text font-weight-bold">To:</strong> {{ item.request_time_to}}</span><br />
                            <span class="red--text "><strong class="black--text font-weight-bold">Hours:</strong> {{
                                item.request_hours }}</span>
                        </div>
                    </template>
                    <template v-slot:[`item.allWorkingHrs`]="{item}">
                    <span v-if="item.attendance != null">{{ item.attendance.day_out_time != null ? formatWorkingHours(item.attendance.working_hours) : "Not Yet" }}</span>
                    <span v-else>{{ "No Attendance" }}</span>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                        style="
                            width: 90% !important;
                            background-color: #fce6e6 !important;
                            border: 1px solid #f00 !important;
                            color: #f00 !important;
                        "
                        variant="outlined"
                        @click="openOvertimeRequestAction(item)"
                        >
                        Reject
                        </v-btn>
                    </template>
                </v-data-table>

        <v-dialog
          v-model="rejectRequestdialog"
          max-height="700"
          id="app_lead_list"
          max-width="600"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    REJECT REQUEST
                  </v-card-title>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="rejectRequestdialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <!-- Form Content -->
              <v-card-text>
                <v-form ref="form">
                  <v-autocomplete
                    v-model="selectedRejectReason"
                    :items="rejectReasons"
                    label="Select Reason"
                    outlined
                  ></v-autocomplete>
                  <v-textarea
                  v-if="selectedRejectReason == 'Other'"
                    v-model="rejectReason"
                    label="Message"
                    placeholder="Enter your message"
                    :counter="maxChars"
                    :maxlength="maxChars"
                  ></v-textarea>
                </v-form>
              </v-card-text>

              <!-- Action Buttons -->
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  style="
                    width: 30% !important;
                    background-color: #fdecea !important;
                    border: 1px solid #f44336 !important;
                    color: #f44336 !important;
                  "
                  variant="outlined"
                  @click="rejectRequest"
                  :disabled="!selectedRejectReason || (selectedRejectReason === 'Other' && !rejectReason)"
                >
                  REJECT
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-card>

      <v-snackbar v-model="snackbar" :color="snackbarColor" location="top-right" outlined timeout="3000">
          {{snackbarMessage}}
          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
    </v-container>
  </v-app>
</template>


<script>
import axios from "axios";
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      officeName: "",
      Datename: "",
      MessageName: "",

      search:'',

      rejectRequestdialog: false,
      InRequestdialog: false,
      centerLoading: false,
      userCategory: [],
      officerNames: [],
      snackbar: false,
      snackbarColor:"",
      snackbarMessage:"",
      rejectReason:"",
      officerTitleList:[],
      officersListBasedOnRole:[],
      selectedOfficerTitle:null,
      selectedOfficer:null,

      divisionCodeList:[],
      selectedDivisionCode:null,
      premiseCodeList:[],
      selectedPremiseCode:null,

      startDate:null,
      endDate:null,
       maxChars: 200,

       selectedRejectReason: "",
       rejectReasons: [
          'Customer/Guarantor Visit - Sales and Marketing',
          'Promotion Campaign - Sales and Marketing',
          'Arrears Follow-up - Sales and Marketing',
          'Dealer Point/Car Sale Visit - Sales and Marketing',
          'Vehicle Inspection - Sales and Marketing',
          'Recovery Visit - Recovery',
          'Vehicle Handing Over - Recovery',
          'Mediation Board Visit - Recovery',
          'Police/Court Appearance - Recovery',
          'Third Party Customer Visit - Recovery',
          'Other'
        ],

      dates:null,
      selectedItem: null,
      overtimeRequestList:[],
      userCategoryItems: [{ name: "Category A" }, { name: "Category B" }],
      groupBy: [{ key: "group_by_user", order: "asc" }],
      headers: [
        // {
        //   title: "OFFICER NAME",
        //   align: "start",
        //   sortable: false,
        //   key: "user.name",
        // },
        { title: "DAY IN", key: "dayIn" },
        { title: "DAY OUT", key: "dayOut" },
        { title: "REQUESTED HOURS", key: "request_hours" },
        { title: "ALL WORKING HOURS", key: "allWorkingHrs" },
        { title: "DATE", key: "date" },
        // { title: "ACTION", key: "action" },
      ],
      desserts: [
        {
          officerName: "Mr. Tharindu Chandrasiri",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          RequestedHours: "03 hours",
          AllWorkingHours: "Not Yet",
          date: "2025-01-01",
          action: "",
        },
        {
          officerName: "Mr. Ransilu Obeysekera",
          dayIn: {
            time: "8:23 AM",
            address: "No.22/1, Kumaranakanda Road, Gonapuluwa",
          },
          RequestedHours: "03 hours",
          AllWorkingHours: "Not Yet",
          date: "2025-01-03",
          action: "",
        },
      ],
    };
  },
  created() {
    this.getOfficerTitles();
    this.fetchData();
  },
  computed: {
      filteredOvertimeRequestList() {
        const keyword = this.search?.toLowerCase() || '';

        if (!keyword) return this.overtimeRequestList;

        return this.overtimeRequestList.filter(item => {
          return (
            item?.user?.name?.toLowerCase().includes(keyword) ||
            item?.user?.reg_num?.toLowerCase().includes(keyword) ||
            item?.request_time_from?.toLowerCase().includes(keyword) ||
            item?.request_time_to?.toLowerCase().includes(keyword) ||
            item?.request_hours?.toString().includes(keyword) ||
            item?.description?.toLowerCase().includes(keyword) ||
            item?.attendance?.status?.toLowerCase().includes(keyword) ||
            item?.attendance?.day_in_time?.toLowerCase().includes(keyword) ||
            item?.attendance?.day_out_time?.toLowerCase().includes(keyword) ||
            item?.attendance?.day_in_location?.toLowerCase().includes(keyword) ||
            item?.attendance?.day_out_location?.toLowerCase().includes(keyword)
          );
        });
      }
    },

  watch: {
    selectedOfficerTitle(newVal) {
      this.selectedOfficer = "";
      this.getUserListBasedOnRoles(newVal); // This triggers on every checkbox change
    },

    selectedOfficer(newVal){
      this.selectedOfficer = newVal;
      this.fetchData();
    },
    selectedPremiseCode(newVal){
      this.selectedPremiseCode = newVal;
      this.fetchData();
    },
    selectedDivisionCode(newVal){
      this.selectedDivisionCode = newVal;
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.centerLoading = true;
      this.loading = true;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}api/am/web/OverTime-request-Approved/get`, {startDate:this.startDate, endDate:this.endDate, selectedOfficers: this.selectedOfficer, selectedPremiseCode: this.selectedPremiseCode, selectedDivisionCode: this.selectedDivisionCode}
        );

        if (response.data.success) {
          this.overtimeRequestList = response.data.data;
          // this.tableData = this.processData(response.data.data);
          // this.prepareOfficerItems();
        } else {
          console.error(
            "API request was not successful:"
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.centerLoading = false;
        this.loading = false;
      }
    },

    backPageRoute() {
      this.$router.go(-1);
    },

        getOfficerTitles() {
            this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-user-roles`, {}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officerTitleList = response.data.data;
                    this.divisionCodeList = response.data.divisionCode;
                    this.premiseCodeList = response.data.premiseCode;
                    
                    this.centerLoading = false;
                    
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching dashboard permissions:', error);
                });
            },

            getUserListBasedOnRoles(selectedRoles){
                this.centerLoading = true;
            // const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            axios.post(`${process.env.VUE_APP_API_BASE_URL}api/um/web/get-mobile-users-based-on-roles`, {userRoleId:selectedRoles}, {
                headers: {
                Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                }
            })
                .then(response => {
                    this.officersListBasedOnRole = response.data.data;
                    
                    this.centerLoading = false;
                    
                })
                .catch(error => {
                    this.centerLoading = false;
                    console.error('Error fetching ', error);
                });
            },

            onDateRangeSelected(newDates){
                if(newDates){
                this.dates = newDates;
                
                this.startDate = new Date(this.dates[0]);
                this.startDate.setDate(this.startDate.getDate() + 1);
                this.startDate = this.startDate.toISOString().split('T')[0];
                this.endDate = this.dates.length > 1 ? new Date(this.dates[this.dates.length - 1]).toISOString().split('T')[0] : this.startDate;

                this.fetchData();

                
                }else{
                    this.dates = null;
                    this.startDate = null;
                    this.endDate =  null;
                    this.fetchData();
                }
            },

            openOvertimeRequestAction(item){
              this.selectedItem = JSON.parse(JSON.stringify(item));
              this.selectedRejectReason = "";
              this.rejectRequestdialog = true;
            },

            async approveRequest() {
                try {
                  this.centerLoading = true;
                      const userId = localStorage.getItem('userId');
                      const token = localStorage.getItem('token');

                      axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/approve-overtime-request`, {user_id: userId,selectedRequestID:this.selectedItem.id}, {
                          headers: {
                          Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                          }
                      })// eslint-disable-next-line
                          .then(response => {
                              this.snackbar = true;
                              this.snackbarColor = "success";
                              this.snackbarMessage = "Overtime request was approved successfully.";
                              this.rejectRequestdialog = false;
                              this.centerLoading = false;
                              this.fetchData();
                          })
                          .catch(error => {
                              this.centerLoading = false;
                              this.snackbar = true;
                              this.snackbarColor = "error";
                              this.snackbarMessage = "Overtime request approval has been failed.";
                              console.error('Error fetching', error);
                          });
                  
                } catch (error) {
                  this.centerLoading = false;
                  console.error("Error approving request:", error);
                  this.snackbar = true;
                  this.snackbarColor = "error";
                  this.snackbarMessage = "Overtime request approval has been failed.";
                }
        },

        async rejectRequest() {
          try {
            this.centerLoading = true;
                const userId = localStorage.getItem('userId');
                const token = localStorage.getItem('token');

                if(this.selectedRejectReason != "Other"){
                this.rejectReason = this.selectedRejectReason;
                }

                axios.post(`${process.env.VUE_APP_API_BASE_URL}api/am/web/reject-overtime-request`, {user_id: userId,selectedRequestID:this.selectedItem.id, selectedRequestReason: this.rejectReason}, {
                    headers: {
                    Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
                    }
                })
                // eslint-disable-next-line
                    .then(response => {
                        this.snackbar = true;
                        this.snackbarColor = "success";
                        this.snackbarMessage = "Overtime request was rejected successfully.";
                        this.InRequestdialog = false;
                        this.rejectRequestdialog = false;
                        this.centerLoading = false;
                        this.rejectReason = "";
                        this.selectedRejectReason = "";
                        this.fetchData();
                    })
                    .catch(error => {
                        this.centerLoading = false;
                        this.snackbar = true;
                        this.snackbarColor = "error";
                        this.snackbarMessage = "Overtime request rejection has been failed.";
                        console.error('Error fetching', error);
                    });
            
          } catch (error) {
            this.centerLoading = false;
            console.error("Error approving request:", error);
            this.snackbar = true;
            this.snackbarColor = "error";
            this.snackbarMessage = "Overtime request rejection has been failed.";
          }
        },

        exportExcelOvertimeRequestList() {
          let tableData = [];
              if(this.filteredOvertimeRequestList.length > 0){
                tableData = this.filteredOvertimeRequestList.map((item, index) => ({
                '#': index + 1,
                'Officer Name': item.user.name,
                'EMPLOYEE ID': item.user.reg_num,
                'Day In Date': item.attendance ? item.attendance.day_in_date : "Not Yet",
                'Day In Time': item.attendance ? item.attendance.day_in_time : "Not Yet",
                'Day In Location': item.attendance ? item.attendance.day_in_location : "Not Yet",
                'Requested Hours': item.request_hours,
                'All Working Hours': item.attendance ? item.attendance.working_hours : "Not Yet",
                'Date': item.date,
                'Over Time Request Status': item.overtime_status,
                'Description': item.description,
                }));
              }else{
                tableData = [{
                  '#': '',
                  'Officer Name': '',
                  'EMPLOYEE ID': '',
                  'Day In Date': '',
                  'Day In Time': '',
                  'Day In Location': '',
                  'Requested Hours': '',
                  'All Working Hours': '',
                  'Date': '',
                  'Over Time Request Status': '',
                  'Description': '',
                }];
              }

                const worksheet = XLSX.utils.json_to_sheet(tableData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Overtime Request Approved List');
                XLSX.writeFile(workbook, 'Overtime_request_approve_List.xlsx');

                const fileName = 'Overtime_request_approve_List.xlsx';
                const file_type = 'excel';
                this.logDocumentDownload(fileName,file_type, "Overtime Request Approved List");
            },

            formatWorkingHours(hoursStr) {
              const [hours, minutes] = hoursStr.split(':').map(Number);
              return `${hours} hours ${minutes.toString().padStart(2, '0')} minutes`;
            },

            async logDocumentDownload(fileName,file_type, entityArea) {
                    
                    try {
                    const token = localStorage.getItem('token');
                    const userId = localStorage.getItem('userId');

                    if (!userId) {
                        throw new Error('User ID not found');
                    }

                    // Asynchronous API call to log download
                    const response = await axios.post(`/api/log-document-download`, {
                        user_id: userId,
                        file_type: file_type,
                        file_name: fileName,
                        entity_area: entityArea,

                        headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                        }
                    });

                    if (response.status !== 200) {
                        throw new Error('Failed to log download');
                    }

                    
                    } catch (error) {
                    console.error('Error logging download:', error);
                    }
                },

    isOnTime(time) {
      // Define a threshold for "ON TIME" (Example: Before 8:30 AM)
      const onTimeLimit = "8:30 AM";
      return time <= onTimeLimit; // Returns true if the time is ON TIME
    },

    actionItem(item) {
      console.log("Edit clicked for:", item);
    },
  },
};
</script>

<style scoped>
.blue--text {
  color: blue;
}
</style>
